import axios from 'axios'
import store from '../store'
import { showSessionExpiredModal } from './settings'

// axiosインスタンスを作成
const axiosInstance = axios.create();
// レスポンスインターセプター
axiosInstance.interceptors.response.use(
  (response) => {
    // 正常なレスポンスはそのまま返す
    return response;
  },
  (error) => {
    // 共通エラーハンドリング
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 401:
          // skipAutoHandle401がtrueの場合は個別のエラーハンドリング処理を優先するため、共通エラーハンドリング処理をスキップ
          if (error.config.skipAutoHandle401) {
            break;
          }
          if (typeof window !== 'undefined') {
            // ログインページへのリンクを含むモーダルを表示
            const state = store.getState();
            if (!state.settings.showSessionExpiredModal) {
              store.dispatch(showSessionExpiredModal());
            }
            // エラーハンドリングチェーンを止める
            return new Promise(() => {});
          } else {
            // ブラウザ環境ではない場合
            break;
          }
        case 404:
          // リソースが見つからない
          console.error('リソースが見つかりません');
          break;
        case 500:
        case 502:
        case 503:
          // サーバーエラー
          console.error('サーバーエラーが発生しました');
          break;
        default:
          console.error(`エラーが発生しました (${status}):`, data);
          break;
      }
    } else if (error.request) {
      // リクエストは送信されたがレスポンスがない（ネットワークエラーなど）
      console.error('ネットワークエラー: サーバーに接続できません');
    } else {
      // リクエスト設定時のエラー
      console.error('リクエストエラー:', error.message);
    }

    return Promise.reject(error);
  }
)

export default axiosInstance


// WEBPACK FOOTER //
// ./src/modules/axiosInstance.js